export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14643.f3c1ddd7.jpg";